import api from '../libs/axios';

export const getTransaction = async (params, signal) => {
  const response = await api.get('/transection', {
    params,
    signal,
  });
  return response.data;
};
